import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, unref as _unref } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container-fluid pb-4"
}
const _hoisted_2 = { class: "d-flex justify-content-end mb-3 gap-2" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-5 mb-4" }
const _hoisted_5 = { class: "card h-100" }
const _hoisted_6 = { class: "card-header text-center text-capitalize" }
const _hoisted_7 = { class: "card-body" }
const _hoisted_8 = {
  key: 0,
  class: "text-center mb-3"
}
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 1,
  class: "text-center mb-3"
}
const _hoisted_11 = { class: "table table-sm" }
const _hoisted_12 = {
  class: "text-secondary text-xs",
  scope: "row"
}
const _hoisted_13 = { class: "text-sm font-weight-bold" }
const _hoisted_14 = {
  class: "text-secondary text-xs",
  scope: "row"
}
const _hoisted_15 = { class: "text-sm" }
const _hoisted_16 = {
  class: "text-secondary text-xs",
  scope: "row"
}
const _hoisted_17 = { class: "text-sm" }
const _hoisted_18 = {
  class: "text-secondary text-xs",
  scope: "row"
}
const _hoisted_19 = { class: "text-sm" }
const _hoisted_20 = { class: "d-flex align-items-center gap-1" }
const _hoisted_21 = {
  class: "text-secondary text-xs",
  scope: "row"
}
const _hoisted_22 = {
  class: "text-secondary text-xs",
  scope: "row"
}
const _hoisted_23 = { class: "text-sm" }
const _hoisted_24 = {
  class: "text-secondary text-xs",
  scope: "row"
}
const _hoisted_25 = { class: "text-sm" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = {
  class: "text-secondary text-xs",
  scope: "row"
}
const _hoisted_28 = { class: "text-sm text-warning font-weight-bold" }
const _hoisted_29 = { class: "col-md-7 mb-4" }
const _hoisted_30 = { class: "card h-100" }
const _hoisted_31 = { class: "card-header text-capitalize" }
const _hoisted_32 = { class: "card-body px-0 pt-0" }
const _hoisted_33 = {
  key: 0,
  class: "text-center text-secondary py-4"
}
const _hoisted_34 = { class: "text-sm mb-0" }
const _hoisted_35 = {
  key: 1,
  class: "table align-items-center mb-0"
}
const _hoisted_36 = { class: "text-uppercase text-secondary text-xxs font-weight-bolder" }
const _hoisted_37 = { class: "text-uppercase text-secondary text-xxs font-weight-bolder" }
const _hoisted_38 = { class: "py-1" }
const _hoisted_39 = { class: "text-xs font-weight-bold mb-0" }
const _hoisted_40 = { class: "align-middle" }
const _hoisted_41 = { class: "form-check form-switch mb-0" }
const _hoisted_42 = ["checked", "disabled", "onChange"]
const _hoisted_43 = {
  key: 1,
  class: "text-center py-5"
}

import { ref, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import VehicleRepository from '@/repositories/VehicleRepository'
import ToastService from '@/services/ToastService'
import i18n from '@/plugins/i18n'
import DateHelper from '@/helpers/DateHelper'
import { Vehicle } from '@/types/Vehicle'
import { useSelectableToggle } from '@/composables/useSelectableToggle'


export default /*@__PURE__*/_defineComponent({
  __name: 'Detail',
  setup(__props) {

const route = useRoute()
const router = useRouter()

const vehicle = ref<Vehicle | null>(null)
const loading = ref<boolean>(false)
const { togglingDriverId, toggle } = useSelectableToggle()

onMounted(async () => {
  const id = route.params.id as string
  loading.value = true
  try {
    vehicle.value = await VehicleRepository.findById(id)
  } catch (e: unknown) {
    const err = e as { message?: string }
    ToastService.toast(ToastService.ERROR, i18n.global.t('common.messages.error'), err?.message)
  } finally {
    loading.value = false
  }
})

function onToggle(driverId: string, newValue: boolean): Promise<void> {
  return toggle(vehicle.value, driverId, newValue)
}

function goBack(): void {
  router.back()
}

function formatVehicleDate(value: string | null | undefined): string {
  return DateHelper.normalizeDateInput(value) || '—'
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (vehicle.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("button", {
            onClick: goBack,
            class: "btn btn-sm btn-info"
          }, [
            _cache[0] || (_cache[0] = _createElementVNode("em", { class: "fas fa-arrow-left me-1" }, null, -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('common.actions.back')), 1)
          ]),
          _createVNode(_component_router_link, {
            to: { name: 'vehicles.edit', params: { id: vehicle.value.id } },
            class: "btn btn-sm btn-outline-primary"
          }, {
            default: _withCtx(() => [
              _cache[1] || (_cache[1] = _createElementVNode("em", { class: "fas fa-pencil me-1" }, null, -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('common.actions.edit')), 1)
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("h6", null, _toDisplayString(_ctx.$t('vehicles.forms.detail')), 1)
              ]),
              _createElementVNode("div", _hoisted_7, [
                (vehicle.value.photoUrl)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createElementVNode("img", {
                        src: vehicle.value.photoUrl,
                        class: "img-fluid border-radius-lg",
                        style: {"max-height":"200px"},
                        alt: "Vehicle photo"
                      }, null, 8, _hoisted_9)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_10, [...(_cache[2] || (_cache[2] = [
                      _createElementVNode("em", { class: "fa-solid fa-car-side fa-6x text-secondary" }, null, -1)
                    ]))])),
                _createElementVNode("table", _hoisted_11, [
                  _cache[3] || (_cache[3] = _createElementVNode("caption", { hidden: "" }, null, -1)),
                  _createElementVNode("tbody", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", _hoisted_12, _toDisplayString(_ctx.$t('drivers.fields.plate')), 1),
                      _createElementVNode("td", _hoisted_13, _toDisplayString(vehicle.value.plate), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", _hoisted_14, _toDisplayString(_ctx.$t('drivers.vehicle.brand')), 1),
                      _createElementVNode("td", _hoisted_15, _toDisplayString(vehicle.value.brand), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", _hoisted_16, _toDisplayString(_ctx.$t('drivers.vehicle.model')), 1),
                      _createElementVNode("td", _hoisted_17, _toDisplayString(vehicle.value.model), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", _hoisted_18, _toDisplayString(_ctx.$t('drivers.placeholders.color')), 1),
                      _createElementVNode("td", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, [
                          (vehicle.value.color?.hex)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: "rounded-circle d-inline-block",
                                style: _normalizeStyle([{"width":"16px","height":"16px","border":"1px solid #ccc"}, { backgroundColor: vehicle.value.color.hex }])
                              }, null, 4))
                            : _createCommentVNode("", true),
                          _createTextVNode(" " + _toDisplayString(vehicle.value.color?.name ?? ''), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", _hoisted_21, _toDisplayString(_ctx.$t('common.fields.status')), 1),
                      _createElementVNode("td", null, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["gorda-status-badge", vehicle.value.enabled ? 'gorda-status-badge--success' : 'gorda-status-badge--danger'])
                        }, _toDisplayString(_ctx.$t(vehicle.value.enabled ? 'common.fields.enabled' : 'common.fields.disabled')), 3)
                      ])
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", _hoisted_22, _toDisplayString(_ctx.$t('vehicles.fields.soat_exp')), 1),
                      _createElementVNode("td", _hoisted_23, _toDisplayString(formatVehicleDate(vehicle.value.soat_exp)), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", _hoisted_24, _toDisplayString(_ctx.$t('vehicles.fields.tec_exp')), 1),
                      _createElementVNode("td", _hoisted_25, _toDisplayString(formatVehicleDate(vehicle.value.tec_exp)), 1)
                    ]),
                    (vehicle.value.currently_driven_by)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_26, [
                          _createElementVNode("th", _hoisted_27, _toDisplayString(_ctx.$t('vehicles.fields.currently_driven_by')), 1),
                          _createElementVNode("td", _hoisted_28, _toDisplayString(vehicle.value.currently_driven_by.name), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("h6", null, _toDisplayString(_ctx.$t('vehicles.fields.linked_drivers')), 1)
              ]),
              _createElementVNode("div", _hoisted_32, [
                (!vehicle.value.linked_drivers || vehicle.value.linked_drivers.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                      _cache[4] || (_cache[4] = _createElementVNode("em", { class: "fa-solid fa-users-slash fa-2x mb-2" }, null, -1)),
                      _createElementVNode("p", _hoisted_34, _toDisplayString(_ctx.$t('vehicles.messages.no_linked_drivers')), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("table", _hoisted_35, [
                      _cache[5] || (_cache[5] = _createElementVNode("caption", { hidden: "" }, null, -1)),
                      _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", _hoisted_36, _toDisplayString(_ctx.$t('common.fields.name')), 1),
                          _createElementVNode("th", _hoisted_37, _toDisplayString(_ctx.$t('vehicles.fields.selectable')), 1)
                        ])
                      ]),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(vehicle.value.linked_drivers, (entry) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: entry.driver_id
                          }, [
                            _createElementVNode("td", _hoisted_38, [
                              _createElementVNode("p", _hoisted_39, _toDisplayString(entry.driver_name), 1)
                            ]),
                            _createElementVNode("td", _hoisted_40, [
                              _createElementVNode("div", _hoisted_41, [
                                _createElementVNode("input", {
                                  class: "form-check-input",
                                  type: "checkbox",
                                  role: "switch",
                                  checked: entry.selectable,
                                  disabled: _unref(togglingDriverId) === entry.driver_id,
                                  onChange: ($event: any) => (onToggle(entry.driver_id, !entry.selectable))
                                }, null, 40, _hoisted_42)
                              ])
                            ])
                          ]))
                        }), 128))
                      ])
                    ]))
              ])
            ])
          ])
        ])
      ]))
    : (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_43, [...(_cache[6] || (_cache[6] = [
          _createElementVNode("em", { class: "fas fa-circle-notch fa-spin fa-2x text-secondary" }, null, -1)
        ]))]))
      : _createCommentVNode("", true)
}
}

})